module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/starEmpty@2x-ce375cdd8c0f795c767b0c98768ff25d.png";